const setSelectedStatusFormActions = {
  label: 'Overdue'
};

export default setSelectedStatusFormActions;
